import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty, Input, Modal, Button, Form } from "antd";
import "../../../styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomPagination from "../../CustomWidgets/CustomPagination";

const ProductHistoryTable = ({
    additionalData,
    pagination,
    onRowClick,
    onDelete,
    onSaveEdit,
}) => {
    const { t, i18n } = useTranslation();
    const [flag, setFlag] = useState(false);
    const navigate = useNavigate();
    const allStores = useSelector(
        (state) => state?.storeReducer?.selectedStore?.is_select_all_store
    );

    // ✅ Modal editing states
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [form] = Form.useForm();
const isRTL = i18n?.language === "ar";

    const data = useMemo(() => additionalData || [], [additionalData]);

    useEffect(() => {
        if (additionalData?.length === 0 && !flag) {
            const timer = setTimeout(() => {
                setFlag(true);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [additionalData, flag]);

  const parseChangeValue = (value) => {
  try {
    if (!value || typeof value !== "string") return null;

    const parts = value.split("->").map(v => v.trim());
    if (parts.length !== 2) return null;

    return {
      old: parts[0],
      new: parts[1],
    };
  } catch (e) {
    return null;
  }
};

const formatNumber = (val, showCurrency, currency) => {
  const num = Number(val);

  // covers NaN, null, undefined, "", non-numeric
  if (!isFinite(num)) return "-";

  const formatted = num.toFixed(2);
  const hasDecimal = num % 1 !== 0;
    const formattedNum = hasDecimal ? num.toFixed(2) : num.toString();

  return showCurrency ? `${currency} ${formatted}` : formattedNum;
};


const ChangeCell = ({
  value,
  showCurrency = false,
  currency = "EGP",
}) => {
  let parsed = null;

  try {
    if (typeof value === "string" && value.includes("->")) {
      const parts = value.split("->").map(v => v.trim());
      if (parts.length === 2) {
        parsed = { old: parts[0], new: parts[1] };
      }
    }
  } catch (e) {
    parsed = null;
  }

  // 🚨 fallback – no change format
  if (!parsed) {
    return (
      <div className="text-center">
        {formatNumber(value, showCurrency, currency)}
      </div>
    );
  }

  return (
  <div className="flex items-center justify-center gap-2 whitespace-nowrap">
      <span className="text-red-500">
        {formatNumber(parsed.old, showCurrency, currency)}
      </span>

      <span className="text-gray-400">{isRTL ? "←" : "→"}</span>

      <span className="text-green-600 font-semibold">
        {formatNumber(parsed.new, showCurrency, currency)}
      </span>
    </div>
  );
};



   const columns = useMemo(() => {
  const baseColumns = [
    {
      Header: <div className="text-center w-full">{t("Date & Time")}</div>,
      accessor: "create_date",
      Cell: ({ value }) => (
        <div className="text-center">{value}</div>
      ),
    },
    {
      Header: <div className="text-center w-full">{t("User")}</div>,
      accessor: "create_by",
      Cell: ({ value }) => (
        <div className="text-center">{value}</div>
      ),
    },

    {
      Header: <div className="text-center w-full">{t("Transaction Type")}</div>,
      accessor: "reference",
      Cell: ({ value }) => (
        <div className="text-center">{t(value)}</div>
      ),
    },

    // {
    //   Header: <div className="text-center">{t("Transaction ID")}</div>,
    //   accessor: "reference",
    //   Cell: ({ value }) => (
    //     <div className="text-center">{value}</div>
    //   ),
    // },

    {
      Header: <div className="text-center w-full">{t("Quantity")}</div>,
      accessor: "purchased_qty",
      Cell: ({ value }) => <ChangeCell value={value} />,
    },

    // {
    //   Header: <div className="text-center">{t("Sold Qty")}</div>,
    //   accessor: "sold_qty",
    //   Cell: ({ value }) => (
    //     <div className="text-center">{Number(value).toFixed(2)}</div>
    //   ),
    // },

    // {
    //   Header: <div className="text-center">{t("Balance Qty")}</div>,
    //   accessor: "balance_qty",
    //   Cell: ({ value }) => (
    //     <div className="text-center">{Number(value).toFixed(2)}</div>
    //   ),
    // },

    {
      Header: <div className="text-center w-full">{t("Cost Price")}</div>,
      accessor: "cost_price",
      Cell: ({ value }) => <ChangeCell value={value} showCurrency/>,
    },

    {
      Header: <div className="text-center w-full">{t("Sale Price")}</div>,
      accessor: "sale_price",
      Cell: ({ value }) => <ChangeCell value={value} showCurrency/>,
    },
  ];

  if (allStores) {
    baseColumns.splice(1, 0,
      {
        Header: <div className="text-center w-full">{t("Store")}</div>,
        accessor: "store_name",
        Cell: ({ value }) => (
          <div className="text-center">{value}</div>
        ),
      },
    );
  }

  return baseColumns;
}, [allStores, t]);

    const {
        headerGroups,
        prepareRow,
        page,
        nextPage,
        setPageSize,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: 10 },
        },
        useSortBy,
        usePagination,
        useRowSelect
    );

    const [pageIndex, setpageIndex] = useState(1);

    useEffect(() => {
        const pageDetails = {
            limit: pageSize,
            offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
        };

        if (pageSize) pagination(pageDetails);
    }, [pageSize, pageIndex]);


    return (
        <div
            className="container flex flex-col mx-auto mt-4 ms-4"
            style={{ maxWidth: "100%" }}
        >
            {additionalData?.length === 0 && !flag ? (
                <div className="h-screen w-[90%] mt-2 ">
                    <ShimmerLoader />
                </div>
            ) : (
                <>
                    {/* Header */}
                    <table
                        className="font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                        style={{ tableLayout: "fixed" }}
                    >
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr
                                    key={headerGroup.id}
                                    {...headerGroup.getHeaderGroupProps()}
                                    className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                                >
                                    {headerGroup.headers.map((column) => (
                                        <th
                                            key={column.id}
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            className="py-3 whitespace-nowrap"
                                            style={{ width: column.width }}
                                        >
<div className="flex items-center justify-center text-sm w-full">
                                                {column.render("Header")}
                                                {column.isSorted ? (
                                                    column.isSortedDesc ? (
                                                        <img
                                                            src={Vectorsorting}
                                                            style={{ minHeight: 10, minWidth: 10 }}
                                                            alt="vector"
                                                        />
                                                    ) : (
                                                        <img
                                                            className="rotate-180"
                                                            src={Vectorsorting}
                                                            alt="vector"
                                                        />
                                                    )
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                    </table>

                    {/* Body */}
                    <div
                        className="scrollbar-none bg-[#F7F9FD]"
                        style={{ overflowY: "auto", maxHeight: "600px" }}
                    >
                        <table
                            className="font-normal max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                            style={{ tableLayout: "fixed" }}
                        >
                            <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                                {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                        <tr
                                            key={row.id}
                                            {...row.getRowProps()}
                                            className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                            onClick={() =>
                                                onRowClick && onRowClick(row.original)
                                            }
                                        >
                                            {row.cells.map((cell, index) => (
                                                <td
                                                    key={index}
                                                    {...cell.getCellProps()}
                                                   className={`p-2 text-[#272728] text-sm font-normal text-center ${
  index < row.cells.length - 1 ? "relative" : ""
}`}
                                                    style={{ width: cell.column.width }}
                                                >
                                                    {cell.render("Cell")}
                                                </td>
                                            ))}
                                        </tr>
                                    );
                                })}
                                {page.length === 0 && (
                                    <tr>
                                        <td colSpan={"100%"}>
                                            <Empty
                                                className="mt-10"
                                                description={t("No data available")}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="">
                        <CustomPagination
                            data={data?.length}
                            pageIndex={pageIndex}
                            pageCount={page?.length}
                            canPreviousPage={pageIndex != 1 ? true : false}
                            canNextPage={data?.length == pageSize ? true : false}
                            gotoPage={(page) => {
                                nextPage(page);
                            }}
                            previousPage={() => {
                                setpageIndex(pageIndex - 1);
                            }}
                            nextPage={() => {
                                setpageIndex(pageIndex + 1);
                            }}
                            pageSize={pageSize}
                            setPageSize={(pageSize) => {
                                setPageSize(pageSize);
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default ProductHistoryTable;

